import { Nilable } from "@shared/utils";
import { IMarcadorDTO, MarcadorDTO } from "./Marcador.DTO";

export interface IFunnelDTO {
    id: number;
    name: string;
    bookmark: IMarcadorDTO;
}

export class FunnelDTO {
    public id = 0;
    public nombre = "";
    public marcador = new MarcadorDTO();

    constructor(json: Nilable<Partial<IFunnelDTO>> = null) {
        if (json != null) {
            this.cargarJSON(json);
        }
    }

    public cargarJSON(json: Partial<IFunnelDTO>): void {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.name != null) {
            this.nombre = json.name;
        }
        if (json.bookmark != null) {
            this.marcador = new MarcadorDTO(json.bookmark);
        }
    }

    public toJSON(): IFunnelDTO {
        return {
            id: this.id,
            name: this.nombre,
            bookmark: this.marcador.toJSON()
        };
    }
}
